import Vue from 'vue'
import VueRouter from 'vue-router'
import Signup from '../views/Signup'
import Globe from '../Globe'
import ProfilePage from '../components/profilePage.vue'
import store from '../store/index'

Vue.use(VueRouter)
const routes = [
  {
    name: 'Signup',
    path: '/',
    component: Signup
  },
  {
    name: 'Globe',
    path: '/globe',
    component: Globe,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/profilePage/:userId',
    name: 'profilePage',
    component: ProfilePage
  }
]

const router = new VueRouter({mode:'history' ,routes })
router.beforeEach((to, from, next) => {
  if (to.matched.some(path => path.meta.requiresAuth)) {
    if (router.app.$store.state.auth.isLoggedIn) {
      next()
      return
    }
    next('/')
  } else {
    next()
  }
})

export default router;
